import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Form from '../../../../components/Form';
import Checkbox from '../../../../components/Checkbox';
import messages from './messages';
import '../styles.css';

// had to use <React.Fragment> to be able to test
// https://github.com/airbnb/enzyme/issues/2056
const Services = ({ onChange, initialValue }) =>
  (
    <React.Fragment>
      {
        Object.keys(initialValue).filter((k) => initialValue[k]).map((key) => (
          <Form.Field styleName="field" key={key}>
            <Checkbox
              label={{
                htmlFor: key,
                children: <FormattedMessage {...messages[key]} />,
              }}
              checked={!!Number(initialValue[key].value)}
              onChange={(e) => {
                // instead of boolean value we put '0' or '1'
                const value = e.target.checked === true ? '1' : '0';
                onChange(e, {
                  [key]: { ...initialValue[key], value },
                });
              }}
            />
          </Form.Field>
        ))
      }
    </React.Fragment>
  );

Services.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default Services;
